/* TDC photo lightbox. Shared by every section that shows a photo gallery.
   Usage: a trigger element with data-tdc-gallery="ID" (optional data-tdc-gallery-title="..."),
   plus <script type="application/json" data-tdc-gallery-photos="ID">[{"src": "...", "alt": "..."}]</script>.
   Swipe uses native scroll snapping; arrows, keyboard and the close button are fallbacks. Styles: .tdc-lb in tdc-landing.css. */
(function () {
  if (window.__tdcLightbox) return;
  window.__tdcLightbox = true;

  var ICONS = {
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    prev: '<path d="M15 5l-7 7 7 7"/>',
    next: '<path d="M9 5l7 7-7 7"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICONS[name] + '</svg>';
  }

  var dlg, track, count, title, prev, next, total = 0, idx = 0, opener = null, scrollY = 0;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'tdc-lb';
    dlg.setAttribute('aria-label', 'Photo gallery');
    dlg.innerHTML =
      '<div class="tdc-lb__bar"><span class="tdc-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="tdc-lb__btn tdc-lb__close" aria-label="Close photos">' + icon('close') + '</button></div>' +
      '<div class="tdc-lb__track" tabindex="-1"></div>' +
      '<button type="button" class="tdc-lb__btn tdc-lb__prev" aria-label="Previous photo">' + icon('prev') + '</button>' +
      '<button type="button" class="tdc-lb__btn tdc-lb__next" aria-label="Next photo">' + icon('next') + '</button>' +
      '<p class="tdc-lb__title"></p>';
    document.body.appendChild(dlg);
    track = dlg.querySelector('.tdc-lb__track');
    count = dlg.querySelector('.tdc-lb__count');
    title = dlg.querySelector('.tdc-lb__title');
    prev = dlg.querySelector('.tdc-lb__prev');
    next = dlg.querySelector('.tdc-lb__next');

    prev.addEventListener('click', function () { go(idx - 1, true); });
    next.addEventListener('click', function () { go(idx + 1, true); });
    dlg.querySelector('.tdc-lb__close').addEventListener('click', close);
    // Tapping the dark area around a photo closes the gallery.
    track.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('tdc-lb-open');
      track.innerHTML = '';
      // Put the page back where it was: some browsers (iOS Safari) jump to the top when the scroll lock is removed.
      restoreScroll();
      if (opener && opener.focus) opener.focus({ preventScroll: true });
      requestAnimationFrame(restoreScroll);
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!track.clientWidth) return;
        update(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
    window.addEventListener('resize', function () { if (dlg.open) go(idx, false); });
  }

  function close() { if (dlg.open) dlg.close(); }

  function restoreScroll() {
    if (Math.abs(window.scrollY - scrollY) > 1) window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
  }

  function update(i) {
    idx = Math.max(0, Math.min(total - 1, i));
    count.textContent = total > 1 ? (idx + 1) + ' / ' + total : '';
    prev.disabled = idx === 0;
    next.disabled = idx === total - 1;
    prev.hidden = next.hidden = total < 2;
  }

  function go(i, smooth) {
    i = Math.max(0, Math.min(total - 1, i));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    update(i);
  }

  function sized(src, w) { return /([?&])width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src; }

  function open(photos, heading, from) {
    if (!dlg) build();
    if (typeof dlg.showModal !== 'function' || !photos.length) return;
    opener = from;
    scrollY = window.scrollY;
    total = photos.length;
    track.innerHTML = '';
    photos.forEach(function (p, i) {
      var slide = document.createElement('div');
      slide.className = 'tdc-lb__slide';
      var img = document.createElement('img');
      img.alt = p.alt || heading || '';
      img.decoding = 'async';
      if (i > 1) img.loading = 'lazy';
      img.sizes = '100vw';
      img.srcset = sized(p.src, 800) + ' 800w, ' + sized(p.src, 1200) + ' 1200w, ' + sized(p.src, 1800) + ' 1800w';
      img.src = p.src;
      img.draggable = false;
      slide.appendChild(img);
      track.appendChild(slide);
    });
    title.textContent = heading || '';
    title.hidden = !heading;
    document.documentElement.classList.add('tdc-lb-open');
    dlg.showModal();
    track.scrollLeft = 0;
    update(0);
    track.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tdc-gallery]');
    if (!btn) return;
    var id = btn.getAttribute('data-tdc-gallery');
    var data = document.querySelector('[data-tdc-gallery-photos="' + id + '"]');
    if (!data) return;
    var photos;
    try { photos = JSON.parse(data.textContent); } catch (err) { return; }
    e.preventDefault();
    open(photos, btn.getAttribute('data-tdc-gallery-title') || '', btn);
  });
})();
